import React from 'react';
import { observer } from 'mobx-react';

import { COLORS, ROUTES } from 'shared/constants';
import { useNavigate } from 'shared/hooks';
import { UiButton, UiIcon } from 'shared/uikit-new';

import { LayoutHeaderSearch } from './components/LayoutHeaderSearch';
import { LayoutHeaderUser } from './components/LayoutHeaderUser';

import { LayoutHeaderChatMessages } from './components/LayoutHeaderChatMessages';
import { LayoutNotifications } from '../LayoutNotifications';

import './styles.scss';

export const LayoutHeader = observer(() => {
    const navigate = useNavigate();

    return (
        <div className='layout-header'>
            <div className="layout-header__main">
                <LayoutHeaderSearch />
                <div className='layout-header__aside'>
                    <div className="layout-header__actions">
                        <UiButton
                            onClick={() => navigate(ROUTES.ENTRY_PASSES(true))}
                            style={{
                                backgroundColor: [COLORS._EAECF1, COLORS._C6CAD1],
                                color: [COLORS._2C2F35, COLORS._2C2F35],
                            }}
                        >
                            <UiIcon.IdCard size={20} />
                            <span>Оформить пропуск</span>
                        </UiButton>
                        <UiButton
                            onClick={() => navigate(ROUTES.RESERVATIONS())}
                            style={{
                                backgroundColor: [COLORS._EAECF1, COLORS._C6CAD1],
                                color: [COLORS._2C2F35, COLORS._2C2F35],
                            }}
                        >
                            <UiIcon.MessagesSquare size={20} />
                            <span>Забронировать переговорную</span>
                        </UiButton>
                    </div>
                    <div className='layout-header__icons'>
                        <LayoutHeaderChatMessages />
                        <LayoutNotifications />
                    </div>
                    <LayoutHeaderUser />
                </div>
            </div>
            <div className="layout-header__title"></div>
        </div>
    );
});
